import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getPenalties,
  getPenaltyById,
  getPenaltiesByPKS,
  getPenaltiesByMitra,
  getOverduePenalties,
  createPenalty,
  createPenaltyFromInvoice,
  updatePenalty,
  deletePenalty,
  issuePenalty,
  recordPenaltyPayment,
  waivePenalty,
  disputePenalty,
  resolveDisputePenalty,
} from "libs/api/penalty";

const thunk = (name, fn) =>
  createAsyncThunk(name, async (args = {}) => {
    const { cbPending, cbFulfilled, cbRejected, cbFinally, ...rest } = args;
    try {
      typeof cbPending === "function" && cbPending();
      const response = await fn(rest);
      typeof cbFulfilled === "function" && cbFulfilled(response);
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  });

export const getPenaltiesThunk = thunk(
  "penalty/getAll",
  ({ queryParams = "" }) => getPenalties(queryParams),
);

export const getPenaltyByIdThunk = thunk(
  "penalty/getById",
  ({ id }) => getPenaltyById(id),
);

export const getPenaltiesByPKSThunk = thunk(
  "penalty/getByPKS",
  ({ pks_id }) => getPenaltiesByPKS(pks_id),
);

export const getPenaltiesByMitraThunk = thunk(
  "penalty/getByMitra",
  ({ mitra_id }) => getPenaltiesByMitra(mitra_id),
);

export const getOverduePenaltiesThunk = thunk(
  "penalty/getOverdue",
  () => getOverduePenalties(),
);

export const createPenaltyThunk = thunk(
  "penalty/create",
  ({ body, accessToken }) => createPenalty(body, accessToken),
);

export const createPenaltyFromInvoiceThunk = thunk(
  "penalty/createFromInvoice",
  ({ invoice_id }) => createPenaltyFromInvoice(invoice_id),
);

export const updatePenaltyThunk = thunk(
  "penalty/update",
  ({ id, body, accessToken }) => updatePenalty(id, body, accessToken),
);

export const deletePenaltyThunk = thunk(
  "penalty/delete",
  ({ id }) => deletePenalty(id),
);

export const issuePenaltyThunk = thunk(
  "penalty/issue",
  ({ id }) => issuePenalty(id),
);

export const recordPenaltyPaymentThunk = thunk(
  "penalty/recordPayment",
  ({ id, body }) => recordPenaltyPayment(id, body),
);

export const waivePenaltyThunk = thunk(
  "penalty/waive",
  ({ id, body }) => waivePenalty(id, body),
);

export const disputePenaltyThunk = thunk(
  "penalty/dispute",
  ({ id, body }) => disputePenalty(id, body),
);

export const resolveDisputePenaltyThunk = thunk(
  "penalty/resolveDispute",
  ({ id, body }) => resolveDisputePenalty(id, body),
);
